import React, {useState,useEffect} from 'react';
import {Link,NavLink,useHistory } from 'react-router-dom';
import {ResGet,url} from './component/resapi'
import HeaderTwo from './HeaderTwo'
import noImage from './asset/image/no-image-icon.png';
import imagesLoead from './component/utility/imageLoad'
import {connect} from 'react-redux';
import {isLoading} from "./redux/actions"
import Div100vh from 'react-div-100vh'
function Search(props) {
  let history = useHistory();
  const [Alldata, setAlldata] = useState([])
  const [loading, setloading] = useState(true)
  const [inputSearch,setinputSearch] =  useState(props.match.params.name)
  const [typeSearch,setTypeSearch] =  useState("all")
  const [skipLimit,setSkipLimit] =  useState(0)
  const [loadingScroll, setloadingScroll] = useState(false)
  const [_istyping,setistyping] =  useState(false);
  useEffect(()=>{
    setinputSearch(props.match.params.name)
    setloading(true)
    var query ="";
    if(typeSearch==="all"){
       query=`search/${props.match.params.name}/0`
    }
    else {
      query=`search/${typeSearch}/${props.match.params.name}/0`
    }
    ResGet(query).then(async(response)=>{
      if(response.status===200){
        await setAlldata(response.data)
        await setloading(false)
        setTimeout(() => {
          imagesLoead(()=>props.isLoading(true))
        }, 1100);
      }
    })
  },[props,typeSearch]);

  useEffect(() => {
    props.isLoading(false)
  }, [])

  useEffect(() => {
    const scrollTarget = document.querySelector(".container")
    function handleReg(){
      if((scrollTarget.scrollTop + scrollTarget.clientHeight) === scrollTarget.scrollHeight){
        if(!loadingScroll){
          setloadingScroll(true)
          var query ="";
          if(typeSearch==="all"){
            query=`search/${props.match.params.name}/${skipLimit+20}`
          }
          else {
            query=`search/${typeSearch}/${props.match.params.name}/${skipLimit+20}`
          }
          ResGet(query).then(async(response)=>{
            if(response.status===200 && response.data.length>0){
              await setAlldata(value=>[...value,...response.data])
              await setSkipLimit(value=> value+20)
              await setloadingScroll(false)
            }
          })
          }
    }
    }
    scrollTarget.addEventListener("scroll", handleReg)
    return ()=>{
      scrollTarget.removeEventListener("scroll", handleReg)
    }
  }, [props,skipLimit,loadingScroll])


  const handelSearch =async(event)=>{
    if (event.key === 'Enter') {
      if(inputSearch!=="") {
        setTypeSearch("all")
        setSkipLimit(0)
        history.push(`/search/${inputSearch}`);
      }
    }
  }
   return (
    <Div100vh style={{height:"100rvh",overflow:"hidden"}}>
     <HeaderTwo w={true}/>
     <div className="bg-fixed-light">
        <div className="container-main">
          <div className="container">
            <div className="header search">
              <div>
              <NavLink to="/" className="clickable">home</NavLink>
              <Link to={`/search/${props.match.params.name}`} className="clickable">Search</Link>
              </div>
              <label>
              <input className="clickable"
                     value={inputSearch}
                     placeholder={"جستجو..."}
                     onBlur={()=>{
                       setinputSearch(props.match.params.name) 
                       setistyping(false)}
                     }
                     onFocus={()=>{setistyping(true);setinputSearch("")}}
                     onChange={ev => setinputSearch(ev.target.value)}
                     onKeyDown={ev=>handelSearch(ev)}
              />
                <span>
                {_istyping && inputSearch===""?<span>|</span>:""}
                {inputSearch==="" && !_istyping?"جستجو":inputSearch}
                </span>
              </label>
            </div>
            <div className="ltr" style={{marginTop:"0.6232em"}}>
            <div className="row">
            {!loading?
            Alldata.length>0?
            Alldata.map((data,key)=>
              <div className="col-lg-3 col-md-6 col-12 mb-1" key={key}>
              <div className="post clickable">
              <div className="image">
                  <Link to={{
                        pathname: data.type==="work" ? `/work/${data.name.split(" ").join("-")}`:`/archive/${data.name.split(" ").join("-")}`,
                        state: { id: data.id }
                        }} ><img src={data.previewAlso?`${url+"/"+data.previewAlso}`:noImage} alt={data.name}/></Link>
              </div>
              <div className="text">
              <Link to={{
                        pathname: data.type==="work"? `/work/${data.name.split(" ").join("-")}`:`/archive/${data.name.split(" ").join("-")}`,
                        state: { id: data.id }
                        }} className="clickable"><h4>{data.name}</h4></Link>
              <Link to={{
                        pathname: data.type==="work"? `/work/${data.name.split(" ").join("-")}`:`/archive/${data.name.split(" ").join("-")}`,
                        state: { id: data.id }
                        }} className="clickable"><p>{data.html}</p></Link>
              </div>
              </div>
            </div>
            )
            :<div className="no-result">
              <div>
              <span>NOT FOUND</span>
              <p>YOU CAN SEE
              <Link to="/work" className="clickable"> WORK </Link>
              OR
              <Link to="/archive" className="clickable"> ARCHIVE </Link>
              
              </p>
              </div>
              </div>
            :""}
            {Alldata.length>0?
              <div className="filter search">
                <span className={`clickable ${typeSearch==="work" && "active"}`} onClick={()=>{setTypeSearch("work");setSkipLimit(0)}}><span>Work</span></span>
                <span className={`clickable ${typeSearch==="archive" && "active"}`} style={{marginLeft:"5em"}} onClick={()=>{setTypeSearch("archive");setSkipLimit(0)}}><span>Archive</span></span>
              </div>
              :""}
            </div>
            </div>
          </div>
        </div>
    </div>
    </Div100vh>
  );
}
export default connect(null,{isLoading})(Search);
